import { Fragment } from "react";

import Button from "@atlaskit/button";
import LoadingButton from "@atlaskit/button/loading-button";
import Form, { Field, type OnSubmitHandler } from "@atlaskit/form";
import TextArea from "@atlaskit/textarea";
import Textfield from "@atlaskit/textfield";

import { BottomNav, FormFooter, FormHeader, FormSection } from "../../ui";

export type InviteTeammateFormProps = {
    readonly goBackNav: (value: boolean) => void;
    readonly onSubmit: OnSubmitHandler<EmailFieldData>;
};

export type EmailFieldData = {
    emailId: string;
};

export const InviteTeammateForm = ({
    onSubmit,
    goBackNav
}: InviteTeammateFormProps) => {
    return (
        <Form<EmailFieldData> onSubmit={onSubmit}>
            {({ formProps, submitting }) => {
                return (
                    <form {...formProps}>
                        <FormHeader
                            title="Invite a teammate to name your site"
                            description="Enter your teammate's email to invite them. This person will also receive admin permissions."
                        />
                        <FormSection>
                            <Field
                                aria-required={true}
                                name="Email"
                                label="Email"
                            >
                                {({ fieldProps }) => (
                                    <Fragment>
                                        <Textfield
                                            autoComplete="off"
                                            {...fieldProps}
                                        />
                                    </Fragment>
                                )}
                            </Field>
                            <Field
                                aria-required={true}
                                name="Confirm email"
                                label="Confirm email"
                            >
                                {({ fieldProps }) => (
                                    <Fragment>
                                        <Textfield
                                            autoComplete="off"
                                            {...fieldProps}
                                        />
                                    </Fragment>
                                )}
                            </Field>
                            <Field
                                name="Custom message"
                                label="Custom message [Optional]"
                            >
                                {({ fieldProps }) => (
                                    <Fragment>
                                        {/* @ts-ignore */}
                                        <TextArea
                                            placeholder="Hi there, these products are almost ready to use. Can you please choose a site name to finish our setup? Let me know if you need any help."
                                            {...fieldProps}
                                        />
                                    </Fragment>
                                )}
                            </Field>
                        </FormSection>
                        <FormFooter>
                            <LoadingButton
                                type="submit"
                                appearance="primary"
                                shouldFitContainer
                                isLoading={submitting}
                                isDisabled={submitting}
                            >
                                Invite
                            </LoadingButton>
                        </FormFooter>

                        <BottomNav>
                            <Button
                                appearance="link"
                                onClick={() => goBackNav(false)}
                            >
                                Go back
                            </Button>
                        </BottomNav>
                    </form>
                );
            }}
        </Form>
    );
};
